import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

import { CoreModule } from "src/app/core/core.module";
import { ContactRoutingModule } from "./contact-routing.module";
import { COMPONENTS } from "./components";

@NgModule({
  providers: [
    // ...SERVICES,
  ],
  exports: [...COMPONENTS],
  imports: [
    CommonModule,
    CoreModule,
    ContactRoutingModule,
    FontAwesomeModule,
    ...COMPONENTS,
  ],
})
export class ContactModule {
  static forRoot(): ModuleWithProviders<ContactModule> {
    return {
      ngModule: ContactModule,
      providers: [],
    };
  }
}
